<template lang="html">
  <div class="audio-model" @click.stop="">
    <div class="audio-control">
      <div class="control-box" @click="togglePlay">
        <i class="ti-control-play" v-if="!isPlay"></i>
        <i class="ti-control-pause" v-else></i>
      </div>
      <div ref="progress" class="progress-control" @click="clickProgress">
        <div class="progress-line" :style="{'width': progress + '%'}"></div>
      </div>
      <div class="time-info">
        <span>{{currentTimeShow}}</span>/<span>{{totalTimeShow}}</span>
      </div>
    </div>
    <audio ref="audio" :src="audioSrc" style="display:none">
    </audio>
  </div>
</template>

<script>
export default {
  props: ['audioSrc'],
  data () {
    return {
      isPlay: false,
      audioEle: null,
      currentTime: 0, // 当前播放时长
      totalTime: 0, // 总播放时长
      timer: null, // 定时器
      progress: 0 // 播放进度
    }
  },
  created () {
    // 监听AUDIO_PLAY
    this.$nextTick(() => {
      if (window.audioEventBus) {
        window.audioEventBus.$on('AUDIO_PLAY', (uid) => {
          // 接受到事件，判断发送事件的id是否是当前组件的id，若不是，则调用暂停
          if (uid === this._uid) return
          this.pause()
        })
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.audioEle = this.$refs.audio
      this.audioEle.addEventListener('ended', () => {
        this.isPlay = false
        this.currentTime = 0
        this.audioEle.currentTime = 0
        this.progress = 0
        clearInterval(this.timer)
      })
      if (this.audioEle.duration) {
        this.totalTime = this.audioEle.duration
      } else {
        this.audioEle.addEventListener('canplay', () => {
          this.totalTime = this.audioEle.duration
        })
      }
    })
  },
  destroyed () {
    window.audioEventBus.$off('AUDIO_PLAY')
  },
  computed: {
    currentTimeShow () {
      return this.calculateCount(this.currentTime)
    },
    totalTimeShow () {
      return this.calculateCount(this.totalTime)
    }
  },
  methods: {
    addZero (num) {
      return num >= 10 ? num : '0' + num
    },
    // 根据传入的时间戳返回..时..分..秒
    calculateCount (time) {
      let hour = Math.floor(time / 60 / 60)
      let minute = Math.floor(time / 60 % 60)
      let second = Math.floor(time % 60)
      return `${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`
    },
    togglePlay () {
      this.isPlay = !this.isPlay
      if (this.isPlay) {
        this.audioEle.play()
        // emit AUDIO_PLAY
        window.audioEventBus.$emit('AUDIO_PLAY', this._uid)
        // 设置定时器，每s获取当前播放时长，设置播放进度
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          const currentTime = this.audioEle.currentTime
          this.currentTime = currentTime
          this.progress = (this.currentTime / this.totalTime) * 100
        }, 1000)
      } else {
        this.audioEle.pause()
        clearInterval(this.timer)
      }
    },
    pause () {
      this.isPlay = false
      this.audioEle.pause()
    },
    // 点击进度条
    clickProgress (ev) {
      // 根据点击的位置计算百分比，进而计算出播放时间，并设置播放器播放时间
      const ele = this.$refs.progress.getBoundingClientRect()
      const len = ev.clientX - ele.left
      const percent = len / ele.width
      // 设置audio的播放进度
      this.audioEle.currentTime = this.totalTime * percent
      // 设置进度变量
      this.progress = percent * 100
    }
  }
}
</script>

<style lang="less">
.audio-model {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
  margin: 2px 5px;
  .audio-control{
    position: relative;
    width: 270px;
    height: 30px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, .5);
  }
  .control-box{
    width: 30px;
    height: 30px;
    float: left;
    font-size: 16px;
    line-height: 30px;
    color: rgba(255, 255, 255, .6);
    cursor: pointer;
    text-align: center;
    transition: .5s;
    &:hover{
      color: #fff;
    }
    i{
      font-style: normal;
    }
  }
  .progress-control{
    height: 4px;
    margin-top: 12px;
    background-color: rgba(255, 255, 255, .2);
    border-radius: 2px;
    border-radius: 0 6px 6px 0;
    float: left;
    width: 120px;
    transition: .5s;
    cursor: pointer;
    .progress-line{
      height: 4px;
      width: 0;
      background-color: #fff;
      border-radius: 2px;
    }
  }
  .time-info{
    line-height: 30px;
    margin-left: 5px;
    font-size: 12px;
    color: #fff;
    float: left;
    width: 110px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// packages/material-content/src/audio.vue